import { Trip } from 'src/common/external/bambi-api/bambiApi';
import { BADGE_COLOR_VARIANTS, Badge } from 'src/common/primitives/Badge';
type TripImportedBadgeProps = {
  trip: Trip;
};

export const TripImportedBadge: React.FC<TripImportedBadgeProps> = ({
  trip,
}) => {
  if (trip?.one_schema_template_id || trip?.one_schema_template_multi_id) {
    return Badge({
      label: 'Imported',
      color: BADGE_COLOR_VARIANTS.GREEN,
    });
  }

  return null;
};
